import controller from './recent-events.controller';

const template = require('./recent-events.html');

export default {
    bindings: {
        events: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/recent-events/recent-events.component.js